module.exports = __webpack_public_path__ + "img/GS_Profile-Kemotshotse Mmekwa.11ae46fe.png";